import { Component, ErrorHandler, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'

import { MatDialog } from '@angular/material/dialog'

import { LadataanService } from '../_jaettu-angular/service/ladataan.service'
import { KayttajaService } from '../_angular/service/kayttaja.service'
import { VaihdaKieliDialog, VaihdaKieliDialogData } from '../vaihda-kieli.dialog'

@Component({
  selector: '[NoSettingsComponent]',
  templateUrl: './no-settings.component.html',
  styleUrls: ['./login.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoSettingsComponent {
  year = new Date().getFullYear()

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private kayttajaService: KayttajaService,
    private ladataanService: LadataanService,
    private errorHandler: ErrorHandler,
  ) {}

  async kirjauduUlos() {
    this.ladataanService.aloitaLataaminen()
    try {
      await this.kayttajaService.logout()
      await this.router.navigate(['/kirjaudu'])
    } catch (err) {
      this.errorHandler.handleError(err)
    } finally {
      this.ladataanService.lopetaLataaminen()
    }
  }

  vaihdaKieli() {
    const data: VaihdaKieliDialogData = {
      tallenna: false,
    }
    this.dialog.open(VaihdaKieliDialog, { data: data })
  }
}
